export default __webpack_public_path__ + "static/media/camera-button.f7c9ab8c.svg";